export default __webpack_public_path__ + "static/media/doj_calendar.3f9de7ce.svg";